/*
 * Kanzi — product page behaviour
 * ---------------------------------------------------------------
 * Five jobs, all of them things the page was silently failing at:
 *
 *  1. Sold-out variants look sold out. 8 of 16 combinations on the
 *     trousers are unavailable — the whole Gray colourway, and L in
 *     every colour — and the only signal was a hairline red diagonal on
 *     a 35px swatch that wasn't even disabled.
 *  2. A sold-out choice offers a way forward (WhatsApp) instead of a
 *     dead end. Gray and L selling out first is demand data; asking for
 *     it back costs the shopper one tap.
 *  3. The discount is said out loud (−30%) rather than implied by a
 *     struck-through number.
 *  4. Low stock is stated when it's true, and only when it's true.
 *  5. The gallery counter counts the colour you're looking at, not the
 *     whole catalogue of 17 images.
 *
 * IMPLEMENTATION NOTE
 * The visible variant controls belong to the Globo Product Options app,
 * not the theme — the theme's own <variant-picker> renders at 0x0. So
 * selection is read from Globo's radios (name="globo-option-N"), and
 * labels are matched to those radios through label[for] -> input.id,
 * which is the only stable link in that markup.
 */
(function () {
  var P = (window.KZ || {}).pdp;
  if (!P || !P.variants || !P.variants.length) return;

  /* The "Kanzi design system" section owns these; the Liquid defaults
     are only used if that section has been removed from the theme. */
  if (window.KZ.whatsapp) P.whatsapp = window.KZ.whatsapp;
  if (window.KZ.lowStockAt != null) P.lowStockAt = window.KZ.lowStockAt;

  var names = P.optionNames || [];

  /* ── selection ─────────────────────────────────────────────── */

  function selected() {
    var out = names.map(function () { return null; });
    document.querySelectorAll('input[name^="globo-option"]:checked').forEach(function (i) {
      var idx = parseInt(i.name.split('-').pop(), 10);
      if (!isNaN(idx) && idx < out.length) out[idx] = i.value;
    });
    return out;
  }

  function exactVariant(vals) {
    for (var i = 0; i < P.variants.length; i++) {
      var v = P.variants[i];
      var hit = true;
      for (var o = 0; o < vals.length; o++) if (v.options[o] !== vals[o]) { hit = false; break; }
      if (hit) return v;
    }
    return null;
  }

  /* Any available variant matching the non-null slots of `vals`. */
  function anyAvailable(vals) {
    return P.variants.some(function (v) {
      if (!v.available) return false;
      for (var o = 0; o < vals.length; o++) {
        if (vals[o] != null && v.options[o] !== vals[o]) return false;
      }
      return true;
    });
  }

  /* ── 1. grey out what can't be bought ──────────────────────── */

  function markOptions() {
    var sel = selected();
    document.querySelectorAll('.product-details .globo-swatch-list label[for]').forEach(function (lb) {
      var input = document.getElementById(lb.htmlFor);
      if (!input || input.name.indexOf('globo-option') !== 0) return;
      var idx = parseInt(input.name.split('-').pop(), 10);
      if (isNaN(idx)) return;

      /* Probe against the options chosen BEFORE this one only. Probing
         against later choices too would grey out every colour the moment
         a shopper picks a size that happens to be gone — technically
         true, useless to read. */
      var probe = names.map(function () { return null; });
      for (var i = 0; i < idx; i++) probe[i] = sel[i];
      probe[idx] = input.value;

      lb.classList.toggle('kzp-out', !anyAvailable(probe));
    });
  }

  /* ── 2. a way forward when it's gone ───────────────────────── */

  function ensureNotify() {
    var atc = document.querySelector('.product-details add-to-cart-component');
    if (!atc) return null;

    /* The button's parent is a <span>, so the note goes AFTER that span
       rather than inside it — a div inside an inline span is invalid and
       renders unpredictably. */
    var anchor = atc.parentElement;
    var note = document.querySelector('.product-details .kzp-soldnote');
    if (note) return note;

    note = document.createElement('div');
    note.className = 'kzp-soldnote';
    note.hidden = true;
    note.innerHTML = '<p style="margin:0 0 10px">Sold out in this combination.</p>';

    if (P.whatsapp) {
      var a = document.createElement('a');
      a.className = 'kzp-notify';
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = 'Ask us on WhatsApp';
      note.appendChild(a);
    }
    anchor.parentElement.insertBefore(note, anchor.nextSibling);
    return note;
  }

  function updateAvailabilityMessage() {
    var note = ensureNotify();
    if (!note) return;
    var vals = selected();
    var complete = vals.every(function (v) { return v != null; });
    var v = complete ? exactVariant(vals) : null;
    var sold = complete && (!v || !v.available);

    note.hidden = !sold;
    if (!sold) return;

    var link = note.querySelector('.kzp-notify');
    if (link && P.whatsapp) {
      var msg = 'Hi Kanzi — I want ' + P.title + ' in ' + vals.join(' / ') +
        '. Can you tell me when it is back?\n' + P.url;
      link.href = 'https://wa.me/' + P.whatsapp + '?text=' + encodeURIComponent(msg);
    }
  }

  /* ── 3. say the discount out loud ──────────────────────────── */

  function num(el) {
    if (!el) return null;
    var m = el.textContent.replace(/[^\d.,]/g, '').replace(/,/g, '.');
    var f = parseFloat(m);
    return isNaN(f) ? null : f;
  }

  /* MUST BE IDEMPOTENT.
     The first version removed and re-inserted the chip on every call,
     while a MutationObserver on the price container called it back on
     every change — so the moment a product actually had a compare-at
     price, each write triggered the observer that triggered the write.
     An endless 40ms loop that only appeared once real sale prices were
     entered. Now: if the chip is already correct, touch nothing. */
  function saveBadge() {
    var priceEl = document.querySelector('.product-details .price');
    var wasEl = document.querySelector('.product-details .compare-at-price');
    var chip = document.querySelector('.product-details .kzp-save');

    function drop() { if (chip) chip.remove(); }

    if (!priceEl || !wasEl) return drop();

    var now = num(priceEl), was = num(wasEl);
    if (!now || !was || was <= now) return drop();

    var pct = Math.round((1 - now / was) * 100);
    if (pct < 1) return drop();

    var label = '−' + pct + '%';
    if (chip) {
      if (chip.textContent !== label) chip.textContent = label;
      return;                                  // no insert, no mutation, no loop
    }
    chip = document.createElement('span');
    chip.className = 'kzp-save';
    chip.textContent = label;
    wasEl.insertAdjacentElement('afterend', chip);
  }

  /* ── 4. low stock, only when true ──────────────────────────── */

  function lowStock() {
    var host = document.querySelector('.product-details .product-inventory');
    if (!host) return;
    var tag = host.querySelector('.kzp-low');
    var vals = selected();
    var v = vals.every(function (x) { return x != null; }) ? exactVariant(vals) : null;
    var limit = P.lowStockAt || 0;
    var show = v && v.available && v.qty != null && limit > 0 && v.qty <= limit && v.qty > 0;

    if (!show) { if (tag) tag.remove(); return; }
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'kzp-low product-inventory__text';
      host.appendChild(tag);
    }
    tag.textContent = ' — only ' + v.qty + ' left';
  }

  /* ── 5. gallery counter for the selected colour ────────────── */

  function gallery() {
    var g = document.querySelector('media-gallery');
    if (!g) return null;
    return g;
  }

  function setupCounter() {
    var g = gallery();
    if (!g) return;

    /* The theme's counter is hidden in CSS, not here — setting the
       hidden attribute lost to its own display:flex and both counters
       rendered on top of each other. But its <span ref="current"> still
       tracks the slide correctly, so we read from it rather than
       guessing at scroll position, and only translate the absolute
       index into a position within the visible colour band. */
    var theirs = document.querySelector('.slideshow-controls__counter [ref="current"]');

    var ours = g.querySelector('.kzp-counter');
    if (!ours) {
      ours = document.createElement('div');
      ours.className = 'kzp-counter';
      g.appendChild(ours);
    }

    function allSlides() {
      return [].slice.call(g.querySelectorAll('slideshow-slide'));
    }
    function visibleSlides() {
      return allSlides().filter(function (s) { return !s.hasAttribute('hidden'); });
    }

    var current = 0;                       // index within the VISIBLE band

    function readTheirs() {
      if (!theirs) return null;
      var abs = parseInt(theirs.textContent, 10);
      if (isNaN(abs)) return null;
      var slide = allSlides()[abs - 1];    // their counter is 1-based, absolute
      if (!slide) return null;
      var i = visibleSlides().indexOf(slide);
      return i > -1 ? i : null;
    }

    function paint() {
      var list = visibleSlides();
      if (!list.length) { ours.hidden = true; return; }
      ours.hidden = false;
      ours.textContent = (Math.min(current, list.length - 1) + 1) + ' / ' + list.length;
    }

    function sync() {
      var i = readTheirs();
      if (i != null) current = i;
      paint();
    }
    sync();

    if (theirs) {
      new MutationObserver(sync).observe(theirs, {
        childList: true, characterData: true, subtree: true
      });
    } else {
      /* no counter in this gallery style — fall back to watching which
         slide is actually on screen */
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.intersectionRatio < 0.55) return;
          var i = visibleSlides().indexOf(e.target);
          if (i > -1) { current = i; paint(); }
        });
      }, { root: null, threshold: [0.55] });
      visibleSlides().forEach(function (s) { io.observe(s); });
    }

    /* a colour change re-hides slides, so the band — and the total —
       changes underneath us */
    new MutationObserver(function (muts) {
      var relevant = muts.some(function (m) {
        return m.type === 'attributes' && m.attributeName === 'hidden';
      });
      if (relevant) { current = 0; sync(); }
    }).observe(g, { attributes: true, attributeFilter: ['hidden'], subtree: true });
  }

  /* ── 5b. drop accordion rows that have nothing in them ─────────
     Liquid can't remove the row it is rendering inside — the row is a
     template block, and a snippet that outputs nothing still leaves the
     heading sitting there with an empty body behind it. So the snippets
     leave a marker and this takes the whole row out.

     An accordion labelled "Size Guide" that opens onto an apology costs
     more trust than no size guide at all. */
  function dropEmptyRows() {
    document.querySelectorAll('.product-details [data-kzp-empty]').forEach(function (marker) {
      var row = marker.closest('details');
      if (row) row.remove(); else marker.remove();
    });
  }

  /* "When Will I Get My Order?" is an app slot — the row holds nothing
     but <div id="ss-delivery"></div> and the delivery-timer app fills it
     in. When the app doesn't answer, the shopper opens a question and
     gets a blank panel. Same rule as the size guide: give it a moment,
     then take the row away if it's still empty. */
  function dropUnfilledAppRows() {
    ['ss-delivery', 'ss-product-video-3'].forEach(function (id) {
      var slot = document.getElementById(id);
      if (!slot) return;
      if (slot.textContent.trim() || slot.children.length) return;
      var row = slot.closest('details');
      if (row) row.remove();
    });
  }

  /* ── 5c. no size is chosen for you ─────────────────────────────
     The app arrives with S already selected. That is a decision made on
     the shopper's behalf, and the cost of getting it wrong is a return.
     Same rule as the card panel: start with nothing chosen, and let the
     button say what it needs instead of failing when pressed. */

  var SIZE_RE = /^(xxs|xs|s|m|l|xl|xxl|xxxl|2xl|3xl|one size|o\/s|os|\d{2,3})$/i;
  var sizeOptionIndex = -1;
  var userPickedSize = false;

  function findSizeIndex() {
    if (sizeOptionIndex > -1) return sizeOptionIndex;
    for (var i = 0; i < names.length; i++) {
      if (/size|مقاس/i.test(names[i])) { sizeOptionIndex = i; return i; }
    }
    for (var j = 0; j < names.length; j++) {
      if (P.variants.some(function (v) { return SIZE_RE.test(String(v.options[j]).trim()); })) {
        sizeOptionIndex = j; return j;
      }
    }
    return -1;
  }

  function sizeInputs() {
    var idx = findSizeIndex();
    if (idx < 0) return [];
    return [].slice.call(document.querySelectorAll('input[name="globo-option-' + idx + '"]'));
  }

  function clearSize() {
    if (userPickedSize) return;
    var inputs = sizeInputs();
    if (!inputs.length) return;
    inputs.forEach(function (i) {
      i.checked = false;
      var lb = document.querySelector('label[for="' + i.id + '"]');
      if (!lb) return;
      /* the app marks its own selection with a class we don't control,
         so strip the usual suspects rather than guess just one */
      ['selected', 'is-selected', 'active', 'is-active', 'globo-selected']
        .forEach(function (c) { lb.classList.remove(c); });
    });
  }

  function sizeChosen() {
    var inputs = sizeInputs();
    if (!inputs.length) return true;              // product has no sizes
    return inputs.some(function (i) { return i.checked; });
  }

  function askForSize() {
    var list = document.querySelector('.product-details .globo-swatch-list');
    if (!list) return;
    list.classList.remove('kzp-ask');
    void list.offsetWidth;
    list.classList.add('kzp-ask');
    list.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* The button used to flip between "Select a size" and its original
     label, and because this ran last it overwrote "Add to bag" on every
     pass. The page button now has one job and one word for it; asking
     for a size is the sheet's job. */
  /* VERIFIED BROKEN ON THE PREVIEW, 27 Jul: this used to write into
     btn.querySelector('span') — "the first span". Once the price was
     injected as the button's first child, the FIRST span WAS the price,
     so the label overwrote it and the button read "Add to bag Add to
     bag" with no price at all. Target the theme's own label span. */
  function labelButton() {
    document.querySelectorAll('add-to-cart-component button').forEach(function (btn) {
      var span = btn.querySelector('.add-to-cart-text');
      if (!span) return;
      if (span.textContent.trim() !== 'Add to bag') span.textContent = 'Add to bag';
      btn.classList.remove('kzp-needsize');
    });
  }

  /* capture phase: stop the theme's own handler before it adds anything */
  document.addEventListener('click', function (e) {
    /* Not scoped to .product-details any more. The theme also renders a
       sticky add-to-cart bar with its own button, and that one was NOT
       intercepted — pressing it really did add Black / S to the bag, a
       size nobody had chosen. Any add-to-cart control on a product page
       now goes through the sheet. */
    var btn = e.target.closest && e.target.closest('add-to-cart-component button, .sticky-add-to-cart__bar button');
    if (!btn) return;
    /* Sizes are no longer in the buy box, so this button can't know which
       variant is meant. It opens the sheet instead — the same one the
       grid uses — and the add happens there. */
    e.preventDefault();
    e.stopPropagation();
    if (!openSheet()) askForSize();
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.name) return;
    if (e.target.name.indexOf('globo-option') !== 0) return;
    var idx = findSizeIndex();
    if (idx > -1 && e.target.name === 'globo-option-' + idx) userPickedSize = true;
    setTimeout(labelButton, 30);
  });

  /* ── 5d. sizes leave the buy box entirely ──────────────────────
     On about:blank the product page has no size selector at all. The
     bottom bar says "add to bag", and pressing it opens the same sheet
     the grid uses. One component, one behaviour: a shopper who learned
     it in the grid already knows it here. So the app's size row and its
     "Size: S" label both come out of the buy box. */

  function hideSizeRow() {
    var idx = findSizeIndex();
    if (idx < 0) return;

    document.querySelectorAll('.product-details .globo-swatch-list label[for]').forEach(function (lb) {
      var input = document.getElementById(lb.htmlFor);
      if (!input || input.name !== 'globo-option-' + idx) return;
      lb.style.display = 'none';
    });

    /* The app prints "Size: S" as <legend class="name-option">, and that
       legend HAS a child element — which is why the first version, which
       only looked at childless nodes, walked straight past it every time.
       Match on the legend itself and read the option name off it. */
    var label = (names[idx] || '').toLowerCase();
    if (!label) return;
    document.querySelectorAll('.product-details legend.name-option').forEach(function (lg) {
      var t = lg.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (t.indexOf(label + ':') === 0 || t === label) lg.style.display = 'none';
    });
  }

  function openSheet() {
    if (typeof (window.KZ || {}).openSizeSheet !== 'function') return false;
    var vals = selected();

    /* Size is deliberately unselected, so exactVariant() never matches
       and the old fallback grabbed "first available" — which is Black.
       Pick Beige, get a picture of the black trousers. Match on the
       options the shopper HAS chosen and ignore the ones they haven't. */
    var v = P.variants.find(function (x) {
      if (!x.available) return false;
      for (var i = 0; i < vals.length; i++) {
        if (vals[i] != null && x.options[i] !== vals[i]) return false;
      }
      return true;
    }) || exactVariant(vals) || P.variants.find(function (x) { return x.available; });

    window.KZ.openSizeSheet({ handle: P.handle, variantId: v && v.id });
    return true;
  }

  /* the in-flow button and the sticky bar both open the sheet */
  function wireBuyButton() {
    var btn = document.querySelector('.product-details add-to-cart-component button');
    if (!btn || btn.dataset.kzpWired) return;
    btn.dataset.kzpWired = '1';
    var span = btn.querySelector('span') || btn;
    span.textContent = 'Add to bag';
  }

  /* A colour row with one chip, or the size row now living in the
     sheet, leaves its legend and its margins behind — a band of white
     nothing in the middle of the buy box. If a group has no control the
     shopper can actually use, the group goes. */
  function collapseEmptyOptions() {
    document.querySelectorAll('.product-details fieldset, .product-details .swatch--gl').forEach(function (group) {
      var labels = group.querySelectorAll('label[for]');
      if (!labels.length) return;
      var usable = 0;
      labels.forEach(function (lb) {
        if (getComputedStyle(lb).display !== 'none') usable++;
      });
      group.classList.toggle('kzp-emptyopt', usable < 2);
    });
  }

  function hideQuantity() {
    document.querySelectorAll('.product-details quantity-selector, .product-details .quantity-selector')
      .forEach(function (el) { el.style.display = 'none'; });
  }

  /* ONE bar, not two.
     The old version bolted a position:fixed bar onto <body> while the
     theme's own button stayed in the page — so the product page carried
     two "add to bag" controls, one of them permanently glued to the
     bottom of the screen on every scroll position.

     about:blank has one control: it sits in the page, sticks to the
     bottom of the viewport while you scroll past it, and comes to rest
     when its container ends. That is exactly position:sticky with
     bottom:0 — no scroll listeners, no second element. */
  function stickyBar() {
    var atc = document.querySelector('.product-details add-to-cart-component');
    if (!atc) return;

    var wrap = atc.closest('.kzp-buy');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'kzp-buy';
      atc.parentElement.insertBefore(wrap, atc);
      wrap.appendChild(atc);
    }

    var btn = atc.querySelector('button');
    if (!btn) return;

    var slot = btn.querySelector('.kzp-price');
    if (!slot) {
      slot = document.createElement('span');
      slot.className = 'kzp-price';
      btn.insertBefore(slot, btn.firstChild);
    }
    var priceEl = document.querySelector('.product-details .price');
    var t = priceEl ? priceEl.textContent.trim() : '';
    if (t && slot.textContent !== t) slot.textContent = t;

    floatWhileAbove(wrap, atc);
  }

  /* ── follow, then stop ──────────────────────────────────────────
     about:blank's buy bar rides the bottom of the screen while you
     scroll and comes to rest when it reaches where it actually lives in
     the page.

     position:sticky expresses that in one line, but it is silently
     killed by ANY ancestor with overflow hidden/clip/auto — and this
     button sits inside the theme's product-details column, a group
     block, and a sticky-content wrapper, none of which I control. Rather
     than gamble on all three, measure it: while the button's real
     position is still below the fold, pin a copy of it to the bottom of
     the viewport; the moment its real position scrolls into view, drop
     the pin and let it sit where it belongs. */
  function floatWhileAbove(wrap, atc) {
    if (wrap.dataset.kzpFloat === '1') return;
    wrap.dataset.kzpFloat = '1';

    var raf = null;

    function measure() {
      raf = null;
      /* Desktop keeps it in the flow — a bar glued to the bottom of a
         1400px screen is a phone pattern. */
      if (!window.matchMedia('(max-width: 767px)').matches) {
        wrap.classList.remove('is-floating');
        wrap.style.minHeight = '';
        return;
      }

      var rect = wrap.getBoundingClientRect();
      var h = atc.offsetHeight || rect.height;
      var restingBottom = rect.top + h;          // where it wants to sit
      var shouldFloat = restingBottom > window.innerHeight;

      if (shouldFloat) {
        /* hold the space so releasing the pin doesn't jump the page */
        if (!wrap.style.minHeight) wrap.style.minHeight = h + 'px';
        wrap.classList.add('is-floating');
      } else {
        wrap.classList.remove('is-floating');
        wrap.style.minHeight = '';
      }
    }

    function schedule() { if (raf == null) raf = requestAnimationFrame(measure); }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    measure();
  }

  /* ── 6. size guide within reach of the size buttons ────────── */

  function sizeAccordion() {
    var found = null;
    document.querySelectorAll('.product-details details').forEach(function (d) {
      var s = d.querySelector('summary');
      if (s && /size/i.test(s.textContent) && !found) found = d;
    });
    return found;
  }

  function setupSizeLink() {
    var list = document.querySelector('.product-details .globo-swatch-list');
    var acc = sizeAccordion();
    if (!list || !acc) return;
    var host = list.parentElement;
    if (!host || host.querySelector('.kzp-sizelink')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kzp-sizelink';
    btn.textContent = 'Size guide';
    btn.addEventListener('click', function () {
      acc.open = true;
      acc.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    host.appendChild(btn);
  }

  /* ── wiring ────────────────────────────────────────────────── */

  function refresh() {
    clearSize();
    hideSizeRow();
    collapseEmptyOptions();
    hideQuantity();
    wireBuyButton();
    labelButton();      // theme label first...
    stickyBar();        // ...then the price, so it can't be overwritten
    markOptions();
    updateAvailabilityMessage();
    lowStock();
    saveBadge();
  }

  /* ── waiting for Globo ─────────────────────────────────────────
     TESTED AND FOUND BROKEN: the first version ran once on load and
     marked nothing, because the Globo app injects its swatches after
     this script executes. Everything downstream — the greying, the
     sold-out note, the size-guide link — silently did nothing until the
     shopper happened to click something.

     So: run on load, watch .product-details for the swatches arriving,
     and keep a few timed retries as a floor. childList only — class
     changes we make ourselves must not re-trigger the observer. */

  function swatchesReady() {
    return !!document.querySelector('.product-details .globo-swatch-list label[for]');
  }

  var settled = false;
  function boot() {
    setupCounter();
    /* before the size-guide link is offered — if the row is going away,
       there is nothing for the link to open */
    dropEmptyRows();
    if (swatchesReady()) {
      setupSizeLink();
      refresh();
      settled = true;
    }
  }

  function watchForSwatches() {
    var host = document.querySelector('.product-details');
    if (!host) return;

    var timer = null;
    new MutationObserver(function () {
      if (!swatchesReady()) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        setupSizeLink();
        refresh();
        settled = true;
      }, 40);
    }).observe(host, { childList: true, subtree: true });

    /* floor: if the app renders in a way the observer misses */
    [250, 800, 2000].forEach(function (ms) {
      setTimeout(function () {
        if (!settled && swatchesReady()) { setupSizeLink(); refresh(); settled = true; }
      }, ms);
    });

    /* generous window for the delivery-timer app before we conclude it
       isn't coming */
    setTimeout(dropUnfilledAppRows, 3000);
  }

  function start() { boot(); watchForSwatches(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* Globo re-renders its radios; a delegated listener survives that */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name && e.target.name.indexOf('globo-option') === 0) {
      setTimeout(refresh, 30);
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.globo-swatch-list')) setTimeout(refresh, 60);
  });

  /* The theme swaps the price node on variant change, so the chip has to
     be recomputed. Two brakes on top of saveBadge being idempotent:
     mutations originating inside our own chip are ignored, and the
     callback is debounced. */
  var priceHost = document.querySelector('.product-details product-price');
  if (priceHost) {
    var timer = null;
    new MutationObserver(function (muts) {
      var ours = muts.every(function (m) {
        var n = m.target;
        return n && n.nodeType === 1 ? n.closest('.kzp-save') : false;
      });
      if (ours) return;
      clearTimeout(timer);
      timer = setTimeout(saveBadge, 60);
    }).observe(priceHost, { childList: true, subtree: true, characterData: true });
  }
})();
